import { IconTypes } from "@/shared/models/icon-types";

export class SearchResults {
    constructor(
        public count: number,
        public results: SearchResult[]
    ){}
}

export class SearchResult {
    constructor(
        public title: string,
        public url: string,
        public icon: IconTypes,
        public highlight: string,
        public categories: string[]
    ){}
}